module.exports = __webpack_public_path__ + "static/media/medium.f423b1e6.svg";